import React, { useState } from "react";
import ModalBasic from "../../component/FormModal";
import SectionWithBorder from "../../../components/membership/membershipTaskList/SectionWithBorder";
import moment from "moment";
import { TextInput } from "../../../components/allTypesInputComponents/AllTypeInputComponents";
import DatePicker from "../../../components/datePicker/DatePicker";
import MultiSelectDropdown from "../../../components/dropdown/MultiSelectDropdown";

const SlotProbationTaskListProcess = (props) => {
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleViewProject = (project) => {
    
    setSelectedProject(project);
    setViewModalOpen(true);
    const data = { ...project };

    data.letterofAwardorPurchaseOrderList = data.letterofAwardorPurchaseOrderDocs
      ? data.letterofAwardorPurchaseOrderDocs.split(',').map(path => ({ path: path.trim() }))
      : [];

    data.certificateOfCompletionFileList = data.certificateOfCompletionPath
      ? data.certificateOfCompletionPath.split(',').map(path => ({ path: path.trim() }))
      : [];

    data.finalInvoiceFilePathList = data.finalInvoiceFilePath
      ? data.finalInvoiceFilePath.split(',').map(path => ({ path: path.trim() }))
      : [];

    // Now set everything in one place
    setSelectedProject(data);
    setViewModalOpen(true);
  };

  const renderTable = (projectList, label) => {
    if (!projectList?.length) return null;



    return (
      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">{label} Project List</h2>
        <div className="table-section">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#e78e3c] text-white">
                <tr>
                  <th className="text-left py-3 px-5">Contract No</th>
                  <th className="text-left py-3 px-5">Project Title</th>
                  {/* <th className="text-left py-3 px-5">Project Location</th> */}
                  <th className="text-left py-3 px-5">Project Type</th>
                  <th className="text-left py-3 px-5">Agency</th>
                  <th className="text-left py-3 px-5">Commencement Date</th>
                  <th className="text-left py-3 px-5">{label == 'Ongoing' ? 'Expected Date of Completion ' : 'Actual Date of Completion'}</th>
                  <th className="text-left py-3 px-5">Award Value</th>
                  <th className="text-left py-3 px-5">Main Contractor Name</th>
                  <th className="text-left py-3 px-5">Contractor Phone</th>
                  <th className="text-left py-3 px-5">Contractor Email</th>
                  <th className="text-left py-3 px-5">Contact Person</th>
                  <th className="text-left py-3 px-5">Action</th>
                </tr>
              </thead>
              <tbody>
                {projectList.map((proj, index) => (
                  <tr key={index} className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]">
                    <td className="text-left py-2 px-5">{proj.contractNo}</td>
                    <td className="text-left py-2 px-5">{proj.projectTitle}</td>
                    {/* <td className="text-left py-2 px-5">{proj.projectLocation}</td> */}
                    <td className="text-left py-2 px-5">{proj.projectType}</td>
                    <td className="text-left py-2 px-5">{proj.agency}</td>
                    <td className="text-left py-2 px-5">
                      {proj.dateOfCommencement
                        ? moment(proj.dateOfCommencement).format("DD-MM-YYYY")
                        : "-"}
                    </td>
                    <td className="text-left py-2 px-5">
                      {label === "Ongoing"
                        ? (moment(proj.expectedDateOfCompletion).isValid()
                          ? moment(proj.expectedDateOfCompletion).format("DD-MM-YYYY")
                          : "-")
                        : (moment(proj.actualDateOfCompletion).isValid()
                          ? moment(proj.actualDateOfCompletion).format("DD-MM-YYYY")
                          : "-")}
                    </td>

                    <td className="text-left py-2 px-5">{proj.awardValue}</td>
                    <td className="text-left py-2 px-5">{proj.mainContractorName}</td>
                    <td className="text-left py-2 px-5">{proj.mainContractorTelephoneNo}</td>
                    <td className="text-left py-2 px-5">{proj.mainContractorEmail}</td>
                    <td className="text-left py-2 px-5">{proj.contactPersonName}</td>
                    <td className="py-2 px-5 text-center">
                      <button
                        className="text-[#e78e3c] font-semibold underline"
                        onClick={() => handleViewProject(proj)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalBasic
        id="add-edit-modal"
        className="membership-add-edit-modal"
        modalOpen={props.setAddeditModalOpen}
        setModalOpen={props.setModalOpen}
        title="Slots Probation Task List Process"
      >
        <div className="px-6 pt-5">
          <SectionWithBorder>
            <div className="px-6 pt-5">
              {/* Company Info */}
              <div className="flex flex-col md:flex-row md:gap-6 mb-3">
                <div className="flex flex-col mb-5 md:mb-0 md:w-1/2">
                  <label className="input-title mb-3">Company Name <span className="text-red-600">*</span></label>
                  <input
                    type="text"
                    value={props.taskDetails.companyName}
                    disabled
                    className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200"
                  />
                </div>
                <div className="flex flex-col md:w-1/2">
                  <label className="input-title mb-3">Company Name (In Chinese)</label>
                  <input
                    type="text"
                    value={props.taskDetails.chineseCompanyName}
                    disabled
                    className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200"
                  />
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:gap-6 mb-3">
                <div className="flex flex-col mb-5 md:mb-0 md:w-1/2">
                  <label className="input-title mb-3">Company UEN <span className="text-red-600">*</span></label>
                  <input
                    type="text"
                    value={props.taskDetails.uenNumber}
                    disabled
                    className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200"
                  />
                </div>
                <div className="flex flex-col md:w-1/2">
                  <label className="input-title mb-3">Email <span className="text-red-600">*</span></label>
                  <input
                    type="text"
                    value={props.taskDetails.businessEmail}
                    disabled
                    className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200"
                  />
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:gap-6 mb-3">
                <div className="flex flex-col mb-5 md:mb-0 md:w-1/2">
                  <label className="input-title mb-3">Subscription End Date <span className="text-red-600">*</span></label>
                  <input
                    type="date"
                    value={
                      props.taskDetails.subcriptionEndDate
                        ? moment(props.taskDetails.subcriptionEndDate).format("YYYY-MM-DD")
                        : ""
                    }
                    disabled
                    className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200"
                  />
                </div>
                <div className="flex flex-col md:w-1/2">
                  <label className="input-title mb-3">Status Name <span className="text-red-600">*</span></label>
                  <input
                    type="text"
                    value={props.taskDetails.statusName}
                    disabled
                    className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200"
                  />
                </div>
              </div>

              {/* Tables */}
              {renderTable(props.ongoingProjectTrackRecordsDetailsList, "Ongoing")}
              {renderTable(props.completedProjectTrackRecordsDetailsList, "Completed")}

              <div className="flex flex-col gap-4 mt-6 mb-6">
                {/* Internal Comment Box */}
                <div>
                  <label className="input-title mb-3">Internal Comment</label>
                  <TextInput
                    name="internalComment"
                    value={props.internalComments.internalComment}
                    //  identity="internal_comment"
                    handleChange={(event) => props.handleChangeForComment(event)}
                    className="w-full border border-gray-300 rounded-md p-2"
                  />
                </div>

                {/* Approve/Reject Buttons */}
                <div className="flex gap-4">

                  {props.taskDetails.statusName !== "Pending" &&
                    props.taskDetails.statusName !== "Approved " &&
                    props.taskDetails.statusName !== "Rejected" && (
                      <>
                        <button
                          className="text-xl font-bold text-[#005B9C] btn-blue-border w-[250px] text-red p-3 mt-4 mr-5"
                          onClick={() => {
                            props.RejectSlotsProbation();
                          }}
                        >
                          Reject Application
                        </button>

                        <button
                          className="text-xl font-bold text-[#005B9C] btn-blue-border w-[250px] text-red p-3 mt-4 mr-5"
                          onClick={() => {
                            props.handleApprove();
                          }}
                        >
                          Approve Application
                        </button>
                      </>
                    )}



                </div>
              </div>

            </div>
          </SectionWithBorder>
        </div>
      </ModalBasic>

      <ModalBasic
        id="add-edit-modal"
        className="membership-add-edit-modal"
        modalOpen={viewModalOpen}
        setModalOpen={setViewModalOpen}
        project={selectedProject}
        title={`${selectedProject?.isOngoing ? "Ongoing" : selectedProject?.isCompleted ? "Completed" : ""} Project Detail`}
      >

        {
          selectedProject !== null ?
            <div className="flex justify-center items-center min-h-[200px]">
              <div className="bg-white p-6 rounded-lg w-full max-w-6xl shadow-md">
                <div className="flex justify-between items-center mb-4">
                  <h1 className="text-xl font-bold text-gray-800"></h1>
                </div>

                <div className="grid grid-cols-1 gap-4 ongoing-project-detail">
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Contract No <span className="text-red-500">*</span></label>
                    <TextInput
                      name="contractNo"
                      value={selectedProject.contractNo}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed  col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1  col-span-6">Project Title <span className="text-red-500">*</span></label>
                    <textarea
                      name="projectTitle"
                      value={selectedProject.projectTitle}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed  col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1  col-span-6">
                      Project Type<span className="text-red-500">*</span>
                    </label>
                    <TextInput
                      name="projectType"
                      value={selectedProject.projectType}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed  col-span-6"
                      disabled={true}
                    />
                  </div>
                  {selectedProject?.projectType === 'Public' && (
                    <div className="grid grid-cols-12 gap-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1  col-span-6">Agency</label>
                      <TextInput
                        name="agency"
                        value={selectedProject.agency}
                        identity="Prject_Tract_Records"
                        className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed  col-span-6"
                        disabled={true}
                      />
                    </div>
                  )}
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1  col-span-6">Project Location <span className="text-red-500">*</span></label>
                    <textarea
                      name="projectLocation"
                      value={selectedProject.projectLocation}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed  col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1  col-span-6">Date of Commencement <span className="text-red-500">*</span></label>
                    <input
                      name="dateOfCommencement"
                      id="dateOfCommencement"
                      type="date"
                      value={moment(selectedProject.dateOfCommencement ? selectedProject.dateOfCommencement : null).format("YYYY-MM-DD")}
                      identity="Prject_Tract_Records"
                      disabled={true}
                      className="form-input w-full shadow-sm border border-gray-300 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed col-span-6" />


                  </div>
                  {selectedProject.isOngoing && (
                    <div className="grid grid-cols-12 gap-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Expected Date of Completion <span className="text-red-500">*</span></label>
                      <input
                        name="expectedDateOfCompletion"
                        id="expectedDateOfCompletion"
                        type="date"
                        value={
                          selectedProject.expectedDateOfCompletion
                            ? moment(selectedProject.expectedDateOfCompletion).format("YYYY-MM-DD")
                            : ""
                        }
                        identity="Prject_Tract_Records"
                        disabled={true}
                        className="form-input w-full shadow-sm border border-gray-300 rounded-md py-2 px-3 text-sm bg-gray-200  cursor-not-allowed col-span-6" />

                    </div>
                  )}
                  {selectedProject.isCompleted && (
                    <div className="grid grid-cols-12 gap-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Actual Date of Completion <span className="text-red-500">*</span></label>
                      <input
                        id="actualDateOfCompletion"
                        name="actualDateOfCompletion"
                        type="date"
                        value={moment(
                          selectedProject.actualDateOfCompletion
                        ).format("YYYY-MM-DD")}
                        identity="Prject_Tract_Records"
                        disabled={true} // or use a prop flag like `props.disableActualDate`
                        className="form-input w-full shadow-sm border border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200  cursor-not-allowed col-span-6" />



                    </div>
                  )}
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Award Value <span className="text-red-500">*</span></label>
                    <TextInput
                      name="awardValue"
                      value={selectedProject.awardValue}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Main Contractor Name <span className="text-red-500">*</span></label>
                    <TextInput
                      name="mainContractorName"
                      value={selectedProject.mainContractorName}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Main Contractor Telephone No. <span className="text-red-500">*</span></label>
                    <TextInput
                      name="mainContractorTelephoneNo"
                      value={selectedProject.mainContractorTelephoneNo}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Main Contractor Email <span className="text-red-500">*</span></label>
                    <TextInput
                      name="mainContractorEmail"
                      value={selectedProject.mainContractorEmail}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed col-span-6"
                      disabled={true}
                    />
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6">Contact Person Name <span className="text-red-500">*</span></label>
                    <TextInput
                      name="contactPersonName"
                      value={selectedProject.contactPersonName}
                      identity="Prject_Tract_Records"
                      className="form-input w-full shadow-sm border-gray-500 rounded-md py-2 px-3 text-sm bg-gray-200 cursor-not-allowed col-span-6"
                      disabled={true}
                    />
                  </div>

                </div>
                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6"
                    htmlFor={`Upload_Project_Tract_Record`}>Supporting Documents <span className="text-red-500">*</span>
                  </label>

                  <div className="mt-6">
                    <label
                      className="block text-sm font-medium text-gray-700 mb-1"
                      htmlFor="Letter_of_Award_or_Purchase"
                    >
                      Letter of Award and/or Purchase Order only
                      <span className="text-red-500">*</span>
                    </label>

                    {/* Hidden File Input */}
                    <input
                      type="file"
                      id="Letter_of_Award_or_Purchase"
                      multiple
                      // onChange={(event) => props.onFileChange(event, "Letter_of_Award_or_Purchase")}
                      className="hidden"
                    />

                    {/* Custom Orange Upload Button */}
                    {/* <label
                      htmlFor="Letter_of_Award_or_Purchase"
                      className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
                    >
                      Upload Files
                    </label> */}

                    {/* Uploaded Files List */}
                    {selectedProject.letterofAwardorPurchaseOrderList?.length > 0 && (
                      <div className="mt-5 space-y-2">
                        {selectedProject.letterofAwardorPurchaseOrderList?.map((file, index) => {
                          let fileName = "Unnamed File";

                          if (typeof file === "string") {
                            fileName = file.split("/").pop() || "Unnamed File";
                          } else if (typeof file?.name === "string") {
                            fileName = file.name;
                          } else if (typeof file?.path === "string") {
                            fileName = file.path.split("/").pop() || "Unnamed File";
                          }

                          return (
                            <div key={index} className="file-uploaded-txt flex items-center text-sm text-black">
                              <img src="/check-orange.png" className="w-[25px] mr-3" alt="Check Icon" />
                              <span>{fileName}</span>

                              <button
                                className="underline text-[#e74c3c] font-[500] ml-3"
                                onClick={() => props.GetSlotsMemberFiles(selectedProject.slotsMemberId, "Award_PurchaseOrder_Docs", fileName)}
                              >
                                Download File
                              </button>

                              {/* <button
                                className="underline text-[#e74c3c] font-[500] ml-3"
                                onClick={() =>
                                  props.deleteFile(
                                    fileName,
                                    props.isCompleted ? "Upload_letter_of_award_Completed" : "Upload_letter_of_award_Ongoing"
                                  )
                                }
                              >
                                <i className="fa fa-trash" aria-hidden="true"></i>
                              </button> */}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>






                  {selectedProject.isCompleted && (
                    <div className="mt-6">
                      <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="Upload_Project_Tract_Record">
                        Certificate of Completion <span className="text-red-500">*</span>
                      </label>

                      {/* Hidden File Input */}
                      <input
                        type="file"
                        id="CertificateOfCompletionPath"
                        multiple
                        // onChange={(event) => props.onFileChange(event, "CertificateOfCompletionPath")}
                        className="hidden"
                      />

                      {/* Custom Square Button */}
                      {/* <label
                        htmlFor="CertificateOfCompletionPath"
                        className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
                      >
                        Upload Files
                      </label> */}

                      {/* Uploaded files list */}
                      {selectedProject.certificateOfCompletionFileList?.length > 0 && (
                        <div className="mt-5 space-y-2">
                          {selectedProject.certificateOfCompletionFileList.map((file, index) => {
                            let fileName = "Unnamed File";

                            if (typeof file === "string") {
                              fileName = file.split("/").pop() || "Unnamed File";
                            } else if (typeof file?.name === "string") {
                              fileName = file.name;
                            } else if (typeof file?.path === "string") {
                              fileName = file.path.split("/").pop() || "Unnamed File";
                            }

                            return (
                              <div key={index} className="file-uploaded-txt flex items-center text-sm text-black">
                                <img src="/check-orange.png" className="w-[25px] mr-3" alt="" />
                                <span>{fileName}</span>

                                <button
                                  className="underline text-[#e74c3c] font-[500] ml-3"
                                  onClick={() => props.GetSlotsMemberFiles(selectedProject.slotsMemberId, "CertificateOfCompletion", fileName)}
                                >
                                  Download File
                                </button>

                                {/* <button
                                  className="underline text-[#e74c3c] font-[500] ml-3"
                                  onClick={() => props.deleteFile(fileName, "Upload_certificate_of_completion")}
                                >
                                  <i className="fa fa-trash" aria-hidden="true"></i>
                                </button> */}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>

                  )}
                  {selectedProject.isCompleted && (
                    <div className="mt-6">
                      <label
                        className="block text-sm font-medium text-gray-700 mb-1"
                        htmlFor="FinalInvoiceFilePath"
                      >
                        Final payment/invoice (Invoice, must be accompanied with payment advices i.e. bank statement (highlighted or transfer slip)) <span className="text-red-500">*</span>
                      </label>

                      {/* Hidden File Input */}
                      <input
                        type="file"
                        id="FinalInvoiceFilePath"
                        multiple
                        onChange={(event) => props.onFileChange(event, "FinalInvoiceFilePath")}
                        className="hidden"
                      />

                      {/* Custom Orange Upload Button */}
                      {/* <label
                        htmlFor="FinalInvoiceFilePath"
                        className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
                      >
                        Upload Files
                      </label> */}

                      {/* Uploaded Files List with Download/Delete */}
                      {selectedProject.finalInvoiceFilePathList?.length > 0 && (
                        <div className="mt-5 space-y-2">
                          {selectedProject.finalInvoiceFilePathList.map((file, index) => {
                            let fileName = "Unnamed File";

                            if (typeof file === "string") {
                              fileName = file.split("/").pop() || "Unnamed File";
                            } else if (typeof file?.name === "string") {
                              fileName = file.name;
                            } else if (typeof file?.path === "string") {
                              fileName = file.path.split("/").pop() || "Unnamed File";
                            }

                            return (
                              <div key={index} className="file-uploaded-txt flex items-center text-sm text-black">
                                <img src="/check-orange.png" className="w-[25px] mr-3" alt="" />
                                <span>{fileName}</span>

                                <button
                                  className="underline text-[#e74c3c] font-[500] ml-3"
                                  onClick={() => props.GetSlotsMemberFiles(selectedProject.slotsMemberId, "FinalInvoiceFile", fileName)}
                                >
                                  Download File
                                </button>

                                {/* <button
                                  className="underline text-[#e74c3c] font-[500] ml-3"
                                  onClick={() => props.deleteFile(fileName, "Upload_final_invoice")}
                                >
                                  <i className="fa fa-trash" aria-hidden="true"></i>
                                </button> */}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>



                  )}
                  {selectedProject.isOngoing && (
                    <div className="mt-6">
                      <label
                        className="block text-sm font-medium text-gray-700 mb-1"
                        htmlFor="FinalInvoiceFilePath"
                      >
                        Form A
                        <span className="text-red-500">*</span>
                      </label>

                      {/* Hidden File Input */}
                      <input
                        type="file"
                        id="FinalInvoiceFilePath"
                        multiple
                        onChange={(event) => props.onFileChange(event, "FinalInvoiceFilePath")}
                        className="hidden"
                      />

                      {/* Custom Orange Upload Button */}
                      {/* <label
                        htmlFor="FinalInvoiceFilePath"
                        className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
                      >
                        Upload Files
                      </label> */}

                      {/* Uploaded Files List with Download/Delete */}
                      {selectedProject.finalInvoiceFilePathList?.length > 0 && (
                        <div className="mt-5 space-y-2">
                          {selectedProject.finalInvoiceFilePathList.map((file, index) => {
                            let fileName = "Unnamed File";

                            if (typeof file === "string") {
                              fileName = file.split("/").pop() || "Unnamed File";
                            } else if (typeof file?.name === "string") {
                              fileName = file.name;
                            } else if (typeof file?.path === "string") {
                              fileName = file.path.split("/").pop() || "Unnamed File";
                            }

                            return (
                              <div key={index} className="file-uploaded-txt flex items-center text-sm text-black">
                                <img src="/check-orange.png" className="w-[25px] mr-3" alt="" />
                                <span>{fileName}</span>

                                <button
                                  className="underline text-[#e74c3c] font-[500] ml-3"
                                  onClick={() => props.GetSlotsMemberFiles(selectedProject.slotsMemberId, "FinalInvoiceFile", fileName)}
                                >
                                  Download File
                                </button>

                                {/* <button
                                  className="underline text-[#e74c3c] font-[500] ml-3"
                                  onClick={() => props.deleteFile(fileName, "Upload_final_invoice")}
                                >
                                  <i className="fa fa-trash" aria-hidden="true"></i>
                                </button> */}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>



                  )}
                </div>
              </div>
            </div>
            : null
        }

      </ModalBasic>

    </>
  );
};

export default SlotProbationTaskListProcess;
